<template>
  <div>
    <common-header title="User Management">
      <template #btn>
        <el-col style="width: 120px;">
          <el-button
            class="btn btn-default btn-outline-pink user_create_btn"
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.CREATE_USER,
              })
            "
          >
            <i class="fas fa-user-plus user_create_btn-i"></i>
            <span class="user_create_btn-text"> Create User </span>
          </el-button>
        </el-col>
      </template>
    </common-header>
    <el-table
      :data="userWithOwnAdvertiser"
      row-key="_id"
      style="font-size: 14px; margin-top:12px;"
      border
    >
      <el-table-column label="" width="20"> </el-table-column>
      <el-table-column
        prop="display_name"
        label="Name"
        min-width="250"
        style="margin-left: 24px"
        sortable
      >
        <template slot-scope="{ row }">
          <div style="font-weight:bold;">
            {{ row.display_name }}
          </div>
          <div>
            {{ row.email }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_level"
        label="Level"
        min-width="100"
        sortable
      ></el-table-column>
      <el-table-column
        prop="service_verified"
        label="Service Verified"
        min-width="300"
        sortable
      >
        <template slot-scope="{ row }">
          <div style="display: flex; ">
            <div :class="{ pink: row.service_verified }">
              {{ row.service_verified ? "Yes" : "No" }}
            </div>
            <div v-if="!row.service_verified" style="margin-left:16px;">
              <el-button
                :class="[
                  { 'btn-outline-pink': !row.resend_count_down },
                  'user_invite_btn',
                ]"
                :disabled="row.resend_count_down > 0"
                @click="resendEmail(row)"
              >
                <i class="fas fa-envelope user_invite_btn-i"></i>
                <span class="user_invite_btn-text"> Resend Invite </span>
                <span v-if="row.resend_count_down">
                  {{ `( ${row.resend_count_down} )` }}
                </span>
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="advertiser" label="Advertiser" min-width="300">
        <template slot-scope="{ row }">
          <div v-if="row.allowed_all_advertiser">
            <div class="pink">
              All
            </div>
          </div>
          <div v-else-if="row.allowed_advertiser.length">
            <el-tag
              style="height:24px; line-height:24px"
              :style="index > 0 ? { marginLeft: '10px' } : ''"
              v-for="(advertiser, index) in row.pass"
              :key="index"
              type="info"
            >
              {{ advertiser }}
            </el-tag>
            <el-tag
              v-if="row.last > 0"
              style="margin-left: 10px; height: 24px; line-height:24px; cursor:pointer"
              type="info"
              @click="
                showDialog({
                  type: CONSTANT.DIALOG_TYPE.USER_MANAGE_ADVERTISER_LIST,
                  row,
                })
              "
            >
              {{ `+${row.last}` }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Operation" min-width="150">
        <template slot-scope="{ row }">
          <el-button
            v-if="row.service_verified"
            class="btn btn-outline-pink"
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.CREATE_USER,
                row: {
                  email: row.email,
                  advertiser_list: row.allowed_advertiser,
                  allowed_all_advertiser: row.allowed_all_advertiser,
                  user_level: row.user_level,
                },
              })
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="bottom"
            >
              <i class="fas fa-pen"></i>
            </el-tooltip>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <dialogs></dialogs>
    <context-menus></context-menus>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import Dialogs from "@/components/common/dialogs/index";
import ContextMenus from "@/components/common/contextMenus/index";
export default {
  data() {
    return {
      userWithOwnAdvertiser: [],
    };
  },
  components: {
    CommonHeader,
    Dialogs,
    ContextMenus,
  },
  computed: {
    ...mapState({
      userList: (state) => state.userManagement.userList,
      advertisers: (state) => state.advertiser.advertisers,
    }),
  },
  async created() {
    if (!this.userList.length) {
      await store.dispatch("userManagement/getUserList");
    }
    if (!this.advertisers.length) {
      await store.dispatch("advertiser/getAdvertisers");
    }
    this.transUserData();
  },
  mounted() {},
  watch: {
    userList: {
      deep: true,
      immediate: true,
      handler: function() {
        this.transUserData();
      },
    },
  },
  methods: {
    ...mapActions({
      showContextMenu: "showContextMenu",
      showDialog: "showDialog",
    }),
    transUserData() {
      this.userWithOwnAdvertiser = [];
      this.userList.forEach((user) => {
        let advertisers_name = [];
        user.allowed_advertiser.forEach((id) => {
          const data = this.advertisers.filter((advertiser) => {
            return advertiser._id === id;
          });
          if (data.length) {
            advertisers_name.push(data[0].name);
          }
        });

        let pass_and_last = this.collapseTag(advertisers_name, 280);
        const res = {
          ...user,
          ...pass_and_last,
          advertisers_name,
          resend_count_down: 0,
        };
        this.userWithOwnAdvertiser.push(res);
      });
    },
    async resendEmail(row) {
      try {
        const inviteData = {
          email: row.email,
          email_verified: row.email_verified,
        };
        await store.dispatch("userManagement/resendInvite", inviteData);
        Vue.prototype.$notify.success({
          title: "Success",
          message: "Resend Email Success",
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
        this.resendCountDownTimer(row, 100);
      } catch (e) {
        Vue.prototype.$notify.error({
          title: "Error",
          message: "Resend Email Error",
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
      }
    },
    updateOneOfUserData(obj, key, value) {
      obj[key] = value;
    },
    resendCountDownTimer(row, seconds) {
      this.updateOneOfUserData(row, "resend_count_down", seconds);
      let counDown = window.setInterval(() => {
        row.resend_count_down = row.resend_count_down - 1;
        if (row.resend_count_down < 0) {
          clearInterval(counDown);
          row.resend_count_down = 0;
        }
      }, 1000);
    },
    collapseTag(item, totalLength) {
      const textWidthUnit = 6;
      const paddingUnit = 20;
      const total = item.length;
      const toralence = 50;
      let accLength = 0 + toralence;
      let pass = [];
      let last = total;
      item.forEach((text) => {
        let arr = text.split("");
        accLength = accLength + paddingUnit;
        accLength = accLength + arr.length * textWidthUnit;
        if (accLength > totalLength) {
          return { pass, last };
        }
        last--;
        pass.push(text);
      });
      return { pass, last };
    },
  },
};
</script>

<style lang="sass" scoped>
.user
  &_create_btn
    width: 120px
    height: 32px
    border: 1px solid $color-pink
    border-radius: 3px
    padding: 9px 14px
    display: flex
    align-items: center
    &-i
      font-size: 12px
    &-text
      font-size: 12px
      margin-left: 8px
      font-weight: unset
      height: 14px
    span
      font-size: 12px !important
  &_invite_btn
    height: 24px
    border: 1px solid $color-pink
    border-radius: 3px
    padding:4px 6px
    display: flex
    align-items: center
    &-i
      font-size: 12px
    &-text
      font-size: 12px
      margin-left: 4px
      font-weight: unset
      height: 14px
    span
      font-size: 12px !important
    &:disabled
      background-color: #F4F4F4
</style>
